<template>
    <div class="image-slider mb-4 mb-md-5  mb-lg-0">
        <div class="match-band swiper" ref="swiperRef">
            <div class="swiper-wrapper" :class="{ 'swiper-grid': !isMobile }">
                <div v-if="images && images?.front" :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box ">
                    <img  :src="images.front" alt="front">
                </div>

                <template v-for="(image, key) in images" :key="key">
                    <div v-if="key !=='front'" :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box p-md-1">
                        <!-- video with key video is displayed in above slide but if there are more than one video those will be shown here -->
                        <video v-if="image?.includes('.mp4')" @contextmenu.prevent="" controlsList="nodownload" ref="video" controls width="400" height="400" autoplay loop muted playsinline>
                            <source :src="image" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
    
                        <iframe v-else-if="image?.includes('.html') || image.includes('loupe360.com')" :src="image" style="width: 100%; height:300px;" class="grid-iframe "></iframe>
    
                        <img v-else :src="image" :alt="key">
                    </div>
                </template>
            </div>

            <div class="match-band-pgtn swiper-pagination"></div>

        </div>
    </div>
</template>
<script setup>
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const { images } = defineProps(['images'])
const { isMobile : isMobile } = useDevice()
const swiperRef = ref(null)


onMounted(() => {
    if (isMobile) {
        new Swiper('.match-band', {
            spaceBetween: 20,
            modules:[Pagination],
            pagination: {
                el: '.match-band-pgtn swiper-pagination',
                clickable: true,
            },
        })
    }
})


onBeforeUnmount( () =>  {

    if (swiperRef?.value?.swiper?.destroy instanceof Function) {
        swiperRef?.value?.swiper?.destroy(true, true);
        console.log("Swiper instance destroyed successfully.");
    }
})



</script>

<style scoped>

@media(min-width:768px){
    img,
    video,
    iframe {
        border: 1px solid #f5f5f5;
    }
}

img,
video,
iframe {
    border-radius: 8px;
}

video {
    width: 100%;
    height: auto;
}



.swiper-grid {
    display: flex;
    flex-wrap: wrap;
}

.swiper-slide-box {
    width: 50%;   
    height: 100%;
}

.swiper-slide-box:first-child {
    width: 100%;
}

img{
    max-width:100%;
    height: auto;
}




.image-slider {
    width: 100%;
    /* height: 100%; */
}


:global(.image-slider .swiper-slide) {
    height: auto !important;
}

/* swiper pagination: mobile */
:global(.image-slider .swiper-pagination) {
    position: relative;
    margin-top: 1.2rem;
}

:global(.image-slider .swiper-pagination-bullet) {
    background: transparent !important;
    opacity: 1 !important;
    margin: 0 5px !important;
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 0 !important;
}

:global(.image-slider .swiper-pagination-bullet::before) {
    content: '';
    position: absolute;
    top: 50%;   
    left: 50%;
    transform: translate(-50%, -50%);
    z-index:   -1;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #c4c4c4 !important;
    opacity: 1 !important;
}

:global(.image-slider .swiper-pagination-bullet-active::before) {
    background: #606060 !important;
}
</style>